<template>
  <div class="tarin-site-info">
    <div class="form-hader-top">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="负责人姓名：" prop="name">
          <span v-if="editType">{{ruleForm.name}}</span>
          <el-input v-else type="text" placeholder v-model="ruleForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="负责人电话：" prop="phone">
          <span v-if="editType">{{ruleForm.phone}}</span>
          <el-input v-else type="text" placeholder v-model="ruleForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="schoolType">
          <span>{{ruleForm.schoolType}}</span>
        </el-form-item>
        <el-form-item v-if="editType" label="地址：" prop="phone">
          <span class="el-icon-location">{{ruleForm.schoolProvince}}省{{ruleForm.schoolCity}}市</span>
        </el-form-item>
        <el-form-item v-else label="地址：" prop="phone">
          <el-col :span="11">
            <el-select v-model="ruleForm.schoolProvince" @visible-change="getCityList" placeholder>
              <el-option
                v-for="item in province"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-select v-model="ruleForm.schoolCity" @visible-change="getAllCityList" placeholder>
              <el-option
                v-for="item in cityList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="培训站点地址" prop="address">
                    <el-input v-model.number="ruleForm.address" placeholder="请输入地址"></el-input>
        </el-form-item>-->
        <!-- <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>-->
        <el-form-item>
          <el-button v-if="editType" type="primary" @click="edit()">修改</el-button>
          <el-button v-else type="primary" @click="saveInfo">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        id: "",
        name: "",
        phone: "",
        schoolType: "",
        schoolProvince: "",
        schoolCity: "",
        address: ""
      },
      editType: true,
      //省
      province: [],
      //市
      cityList: [],
      rules: {
        // name: [
        //     { required: true, message: '请输入姓名', trigger: 'blur' }
        // ],
        // phone: [
        //     { required: true, message: '请输入手机号', trigger: 'blur' }
        // ],
        // address: [
        //     { required: true, message: '请输入地址', trigger: 'blur' }
        // ],
      }
    };
  },
  props: {
    schoolManagerId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getSchoolInfo();
    this.getAllProvinceList();
  },
  methods: {
    //保存修改信息
    saveInfo() {
      var that = this;
      this.$http
        .post("/api/XOrg/XSchool/setSchoolInfo", {
          id: this.ruleForm.id,
          contacts: this.ruleForm.name,
          contactsPhone: this.ruleForm.phone,
          schoolProvince: this.ruleForm.schoolProvince,
          schoolCity: this.ruleForm.schoolCity
        })
        .then(rst => {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.editType = true;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //点击更换信息样式
    edit() {
      this.editType = false;
    },
    //获取所有省
    getAllProvinceList() {
      var that = this;
      this.$http.post("/api/XOrg/Special/getAllProvinceList").then(rst => {
        if (rst.code > 0) {
          that.province = rst.province;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    //获取所有市
    getCityList() {
      var that = this;
      this.$http
        .post("/api/XOrg/Special/getCityList", {
          province: this.ruleForm.schoolProvince
        })
        .then(rst => {
          if (rst.code > 0) {
            that.cityList = rst.cityList;
            that.ruleForm.schoolCity = rst.cityList[2].value;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //获取所有市
    getAllCityList() {
      var that = this;
      this.$http
        .post("/api/XOrg/Special/getCityList", {
          province: this.ruleForm.schoolProvince
        })
        .then(rst => {
          if (rst.code > 0) {
            that.cityList = rst.cityList;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //获取基本信息
    getSchoolInfo() {
      var that = this;
      this.$http
        .post("/api/XOrg/XSchool/getSchoolInfo", {
          id: this.schoolManagerId
        })
        .then(rst => {
          if (rst.code == 1) {
            that.ruleForm.id = rst.info.id;
            that.ruleForm.name = rst.info.contacts;
            that.ruleForm.phone = rst.info.contactsPhone;
            that.ruleForm.schoolType = rst.info.schoolType;
            that.ruleForm.schoolProvince = rst.info.schoolProvince;
            that.ruleForm.schoolCity = rst.info.schoolCity;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
          this.$http.post("", {}).then(res => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.tarin-site-info {
  margin: 20px;
  padding: 20px;
  background: #ffffff;
  .form-hader-top {
    margin-top: 20px;
    width: 600px;
    min-height: 300px;
  }
  .line {
    text-align: center;
  }
}
</style>
